import { Utils, Logger, NumberUtils, StringUtils } from "neo-common";
import { ClientHost, GameEngine, Platforms } from "neo-games";
import { Languages } from "../../../Utils/Languages";
import { FrameTimerEventEmitter, FrameTimerEvents, CreateFrameTimer } from "../../../Utils/FrameTimer";
import { AppContext } from "../../../../Common/AppContext";
import { GameApp } from "../../../GameApp";
import { DataManager } from "../../../Managers/DataManager";
import { GameManager } from "../../../Managers/GameManager";
import { PlayList } from "../../../Components/Sounds/PlayList";
import { FreeRoundBonus } from "../Bonuses/FreeRoundBonus";
import { FreeRoundBonusDialog } from "./FreeRoundBonusDialog";
import { RealityCheckGetInfoResponse } from "neo-games/Engine/Communication/Game/Responses/RealityCheckGetInfoResponse";
import { BetManager } from "../../../Managers/BetManager";
import { MessageManager } from "../../../Managers/MessageManager";
import { Jackpot } from "../Bonuses/Jackpot";
import { BetHigherThanMinDialog } from "./BetHigherThanMinDialog";
import { AutoplayConfirmationDialog } from "./AutoplayConfirmationDialog";

/**
 * Create dialog filled from code.
 * @class Dialog
 */
export class ResponsibleDialog1 {
    static opened: boolean = false;

    static DisabledClass: string = "_disabled";

    private static _element: HTMLElement;
    private static _continueButton: HTMLElement;
    private static _historyButton: HTMLElement;
    private static _closeButton: HTMLElement;

    static showResponsibleDialog1OnCollect: boolean = false;
    static responsibleDialog1Data: ClientHost.Types.ClientHostResponsibleDialogData;

    static openDialog(data: ClientHost.Types.ClientHostResponsibleDialogData): void {
        if (AppContext.gameConfiguration.RCIInfo) {
            GameManager.gameClient.getRealityCheckInfo().then((response: any): any => {
                ResponsibleDialog1.openDialogContinue(data, response);
            });
        } else {
            ResponsibleDialog1.openDialogContinue(data);
        }
    }

    static openDialogContinue(
        data: ClientHost.Types.ClientHostResponsibleDialogData,
        info: RealityCheckGetInfoResponse = null,
    ): void {
        if (ResponsibleDialog1._element == null) {
            ResponsibleDialog1._element = document.getElementById("responsibleGamingDialog");
        }

        if (
            !Utils.isNullOrUndefined(info) &&
            !Utils.isNullOrUndefined(info["messages"]) &&
            info["messages"].length > 0
        ) {
            MessageManager.postpone(ResponsibleDialog1.onContinue, info);
            return;
        }

        let elementWin: HTMLElement = document.getElementById("rciWin");
        let elementLost: HTMLElement = document.getElementById("rciLost");
        let totalGain: number = 0;

        Platforms.Platforms.dialogOpened("rci", true);

        if (info != null) {
            if (info.totalGain <= 0) {
                elementWin.style.display = "none";
                elementLost.style.display = "block";
                totalGain = -1 * info.totalGain;
            } else {
                elementWin.style.display = "block";
                elementLost.style.display = "none";
                totalGain = info.totalGain;
            }
        } else {
            elementWin.style.display = "none";
            elementLost.style.display = "none";
        }

        BetHigherThanMinDialog.hideDialog();
        AutoplayConfirmationDialog.closeDialog();
        AppContext.current.closeDialog();
        FreeRoundBonusDialog.hideDialog();
        FreeRoundBonus.disableUi();
        Jackpot.closeAllHistoryDialogs();
        ResponsibleDialog1.opened = true;

        if (ResponsibleDialog1._continueButton == null) {
            ResponsibleDialog1._continueButton = document.getElementById("continueButton");
            if (ResponsibleDialog1._continueButton != null) {
                ResponsibleDialog1._continueButton.onclick = ResponsibleDialog1.onContinue;
                if (data.continue) {
                    ResponsibleDialog1._continueButton.style.display = "inline-block";
                } else {
                    ResponsibleDialog1._continueButton.style.display = "none";
                }
            }
        }

        if (ResponsibleDialog1._historyButton == null) {
            ResponsibleDialog1._historyButton = document.getElementById("historyButton");
            if (ResponsibleDialog1._historyButton != null) {
                if (data.history) {
                    ResponsibleDialog1._historyButton.onclick = ResponsibleDialog1.onHistory;
                    ResponsibleDialog1._historyButton.style.display = "inline-block";
                } else {
                    if (!StringUtils.isNullOrEmpty(AppContext.gameConfiguration.RCIHistoryUrl)) {
                        ResponsibleDialog1._historyButton.onclick = ResponsibleDialog1.onGameRoundHistory;
                        ResponsibleDialog1._historyButton.style.display = "inline-block";
                    } else {
                        if (AppContext.gameConfiguration.RCIShowHistoryButton) {
                            ResponsibleDialog1._historyButton.onclick = ResponsibleDialog1.onGameRoundHistory;
                            ResponsibleDialog1._historyButton.style.display = "inline-block";
                        } else {
                            ResponsibleDialog1._historyButton.style.display = "none";
                        }
                    }
                }
            }
        }

        if (ResponsibleDialog1._closeButton == null) {
            ResponsibleDialog1._closeButton = document.getElementById("closeButton");
            if (ResponsibleDialog1._closeButton != null) {
                ResponsibleDialog1._closeButton.onclick = ResponsibleDialog1.onClose;
                if (data.exit) {
                    ResponsibleDialog1._closeButton.style.display = "inline-block";
                } else {
                    ResponsibleDialog1._closeButton.style.display = "none";
                }
            }
        }

        //var now: Date = Time;
        var startTime: number = (Date.now() - data.startTime.getTime()) / 1000;
        var interval: string = "";
        var t: number = startTime / 60;
        var h: string = parseInt(t / 60 + "") + "";
        if (parseInt(h) < 10) {
            h = "0" + h;
        }
        var m: string = parseInt((t % 60) + "") + "";
        if (parseInt(m) < 10) {
            m = "0" + m;
        }

        if (data.interval % 60 === 0) {
            interval = (data.interval / 60).toFixed(0);
        } else {
            interval = (data.interval / 60).toFixed(2);
        }

        DataManager.updateDataElement("RESPONSIBLE_DIALOG_1", Math.floor(t) + "");

        if (AppContext.gameConfiguration.RCIInfo) {
            if (info != null) {
                if (DataManager.DisplayCurrencies.hasOwnProperty(info.currency)) {
                    info.currency = DataManager.DisplayCurrencies[info.currency];
                }

                if (AppContext.gameConfiguration.UseCoins && BetManager.CoinSize != null) {
                    DataManager.updateDataElement(
                        "RESPONSIBLE_DIALOG_1_SUM",
                        NumberUtils.devide(totalGain, BetManager.CoinSize).toString() + " " + info.currency,
                    );
                } else {
                    DataManager.updateDataElement(
                        "RESPONSIBLE_DIALOG_1_SUM",
                        Languages.formatText(Languages.FormatMoney, totalGain.toString()) + " " + info.currency,
                    );
                }
            }
        }

        // RCI_IntervalInfo
        DataManager.updateDataElement("RESPONSIBLE_DIALOG_1_INTERVAL", interval);

        let elementRciIntervalInfo = document.getElementById("rciIntervalInfo");
        if (AppContext.gameConfiguration.RCIIntervalInfo) {
            if (elementRciIntervalInfo != null) {
                elementRciIntervalInfo.style.display = "block";
            }
        } else {
            if (elementRciIntervalInfo != null) {
                elementRciIntervalInfo.style.display = "none";
            }
        }

        if (ResponsibleDialog1._element != null) {
            if (ResponsibleDialog1._element.classList.contains(ResponsibleDialog1.DisabledClass)) {
                ResponsibleDialog1._element.classList.remove(ResponsibleDialog1.DisabledClass);
            }
        } else {
            if (DEBUG) {
                Logger.errorGroup("ResponsibleDialog1", "ERROR no responsibleDialog1");
            }
        }
    }

    static onContinue(): void {
        Platforms.Platforms.dialogOpened("rci", false);

        ResponsibleDialog1.opened = false;
        if (!ResponsibleDialog1._element.classList.contains(ResponsibleDialog1.DisabledClass)) {
            ResponsibleDialog1._element.classList.add(ResponsibleDialog1.DisabledClass);
        }

        PlayList.play("SND_Click");
        GameApp.continue();
        GameManager.closeResponsibleDialog1();
        BetHigherThanMinDialog.restoreDialog();
        FreeRoundBonus.reopenFreeRounds();
    }

    static onHistory(): void {
        Platforms.Platforms.dialogOpened("rci", false);

        ResponsibleDialog1.opened = false;
        if (!ResponsibleDialog1._element.classList.contains(ResponsibleDialog1.DisabledClass)) {
            ResponsibleDialog1._element.classList.add(ResponsibleDialog1.DisabledClass);
        }

        PlayList.play("SND_Click");
        GameApp.closeRealityCheck();
        GameApp.history();
        GameManager.closeResponsibleDialog1();
        BetHigherThanMinDialog.restoreDialog();
        FreeRoundBonus.reopenFreeRounds();
    }

    static onGameRoundHistory(): void {
        Platforms.Platforms.dialogOpened("rci", false);

        ResponsibleDialog1.opened = false;
        if (!ResponsibleDialog1._element.classList.contains(ResponsibleDialog1.DisabledClass)) {
            ResponsibleDialog1._element.classList.add(ResponsibleDialog1.DisabledClass);
        }

        PlayList.play("SND_Click");
        GameApp.closeRealityCheck();
        if (!StringUtils.isNullOrEmpty(AppContext.gameConfiguration.RCIHistoryUrl)) {
            GameApp.openGameRoundHistoryFromUrl();
        } else {
            GameApp.openGameRoundHistory();
        }
        GameManager.closeResponsibleDialog1();
        BetHigherThanMinDialog.restoreDialog();
        FreeRoundBonus.reopenFreeRounds();
    }

    static onClose(): void {
        Platforms.Platforms.dialogOpened("rci", false);

        ResponsibleDialog1.opened = false;
        if (!ResponsibleDialog1._element.classList.contains(ResponsibleDialog1.DisabledClass)) {
            ResponsibleDialog1._element.classList.add(ResponsibleDialog1.DisabledClass);
        }

        PlayList.play("SND_Click");
        Platforms.Platforms.exitHandler = "responsibleDialog";
        GameApp.exit();
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Common/Dialogs/ResponsibleDialog1.ts
 **/